module.exports = __webpack_public_path__ + "static/crime-stats-mobile2-7fbedc8687f00201c0a57f3a26ac0060.png";